import { render, staticRenderFns } from "./VeJwCjPutinModal.vue?vue&type=template&id=64144834"
import script from "./VeJwCjPutinModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjPutinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports